/**
 * API client específico para Empresas (Carlos jun 28, 2026)
 * ----------------------------------------------------------
 * Token separado del cliente/admin: lo guarda en localStorage como `empresa_token`.
 * Así una empresa logueada no pisa al admin/cliente que tenga abierto en otra pestaña.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const empresaApi = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

empresaApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('empresa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.params = { ...config.params, _t: Date.now() };
  return config;
});

empresaApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token expirado o inválido → mandar a login empresa
      localStorage.removeItem('empresa_token');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/empresas/login')) {
        window.location.href = '/empresas/login';
      }
    }
    return Promise.reject(err);
  }
);

export default empresaApi;
